import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseServiceV2 } from '@servicesv2';
import { CoresViewModel, ConsultarCoresViewModel } from '../../models/confeccoes/CoresViewModel';
import { ConsultaPaginadaViewModel } from '../../model/model.api';

@Injectable()
export class CoresServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('CoresPecas', http);
  }

  consultarCores(payload: ConsultarCoresViewModel) {
    return this.postPaginatedAsPromise<ConsultarCoresViewModel, ConsultaPaginadaViewModel<CoresViewModel>>(payload, 'consultarCoresPecas');
  }

}